/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateTooltipDto
 */
export interface CreateUpdateTooltipDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTooltipDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTooltipDto
     */
    plText: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTooltipDto
     */
    enText: string;
}

/**
 * Check if a given object implements the CreateUpdateTooltipDto interface.
 */
export function instanceOfCreateUpdateTooltipDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "plText" in value;
    isInstance = isInstance && "enText" in value;

    return isInstance;
}

export function CreateUpdateTooltipDtoFromJSON(json: any): CreateUpdateTooltipDto {
    return CreateUpdateTooltipDtoFromJSONTyped(json, false);
}

export function CreateUpdateTooltipDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateTooltipDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
        'plText': json['plText'],
        'enText': json['enText'],
    };
}

export function CreateUpdateTooltipDtoToJSON(value?: CreateUpdateTooltipDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'plText': value.plText,
        'enText': value.enText,
    };
}

